<template>
  <GestionAnalisisMultiple />
</template>
<script>
import GestionAnalisisMultiple from "./components/GestionAnalisisMultiple";
export default {
  name: "AnalisisScreen",
  components: { GestionAnalisisMultiple }
};
</script>